export default "__VITE_ASSET__rfS_nvSuw5jzARqapwRlEQ__"